import { CamData } from '../cam-data';
import { ManufacturingOrderBuilder } from './manufacturing-order.builder';
import { MaterialBuilder } from './material.builder';
import { PartBuilder } from './part.builder';
import { CamDataValidation } from '../cam-data-validation';

export class CamDataBuilder {
  static fromJson(json) {
    return (json)
      ? new CamData(
        ManufacturingOrderBuilder.fromList(json.manufacturingOrders),
        MaterialBuilder.fromList(json.materials),
        PartBuilder.fromJson(json.part)
      )
      : null;
  }

  static camDataValidationFromJson(json) {
    return (json)
      ? new CamDataValidation(
        json.schedulerTasks,
        json.updatable
      )
      : null;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/cam-data.builder.ts